<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch"
      @showType="showType"
      :filters="filterConfig"
      @filter-search-input="handleFilterSearchInput"
      @filter-value-change="handleFilterValueChange"
      :noResetCall="true"
    />

    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
      <template v-slot:top>
        <table-top-vue
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="getData"
          v-on:exportItemParent="exportItem"
        />
      </template>
        <template slot="action" slot-scope="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
          <v-menu offset-y rounded="lg" transition="slide-y-transition" bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="warning"
              class="mb-2"
              icon
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-icon light size="20">mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item link :to="`/client/aggregator/view/${item.id}`">
              <v-list-item-icon>
                <v-icon>mdi-eye</v-icon>
              </v-list-item-icon>
              <v-list-item-title>View Detail</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="viewListSubMerchant(item)">
              <v-list-item-icon>
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-list-item-icon>
              <v-list-item-title>View List Sub Merchant</v-list-item-title>
            </v-list-item>
          </v-list>
          </v-menu>
        </td>
      </template>
    </TableView>

  </v-card>
</template>

<script>
import aggregatorListMixin from '../../../components/client-list/aggregator-list/aggregatorListMixin';


export default {
  mixins: [ aggregatorListMixin ],
  components: {
    TableTopVue: () => import('../../../components/table/TableTop.vue'),
    TableView: () => import("../../../components/@drontVue/components/Table/TableView.vue"),
    TableSearchFilter: () => import("../../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
  },
};
</script>